import { tag } from '../jsonEditor/tagJsonEditorConfig.js';
export const tags = {
    type: 'tags',
    contentType: 'tag',
    editor: 'json',
    editorTitle: { name: 'title', placeholder: 'title' },
    editorConfig: tag,
    editorContext: 'root',
    supportContent: [],
    title: 'Tag',
    plural: 'Tags',
    endpoint: 'tags',
    listing: {
        type: 'grid',
        gridColumns: ['title'],
        gridContentType: 'tags',
        gridDecode: ['title'],
        gridFilters: [],
        gridHasChildren: false,
        gridJoin: { properties: [] },
        gridSearch: [{ key: 'title', combine: true }],
        gridSupportContent: [],
    },
    queryProperties: ['id', 'title', 'slug'],
    sidebar: {
        status: [],
        version: [{ label: 'Slug', name: 'slug', input: 'text' }],
        versioned: false,
    },
    meta: [],
    validate: [],
};
//# sourceMappingURL=tags.js.map